import { authorCourse, terrainPreset, type HolePlan } from './courseAuthoring';
import { plans } from './coursePlans';
export const windhavenLinksMetadata = {
  id: 'windhaven-links',
  name: 'Windhaven Links',
  description:
    'A traditional tree-free links threaded through tall dunes, compact deep bunkers and firm running contours under a relentless sea wind.',
  environmentPreset: 'windswept-links',
  metadata: {
    location: 'North Sea Coast',
    regionType: 'traditional dune links',
    difficulty: 86,
    typicalWind: [10, 24] as const,
    greenSpeed: [11, 12] as const,
    firmness: 'firm' as const,
    primaryChallenge: 'Traditional links on the exposed coast',
    signatureHoles: [3, 7, 12, 18],
    tournamentEventId: 'event-14',
    previewTheme: 'windswept-links',
    environmentPalette: {
      fairway: '#8c9865',
      rough: '#747552',
      bunker: '#d3b56f',
      water: '#506f76',
      haze: '#aeb8ae',
      sky: '#9bb0bb',
      rock: '#736956',
      wasteArea: '#bca467',
    },
    vegetationStyle: 'almost treeless marram grass',
    terrainStyle: terrainPreset('windswept-links', 20, 150, 1.1).id,
    sunlightDirection: 'low westering coastal sun',
    distantScenery: 'tall dunes and a muted sea horizon',
    waterStyle: 'dark wind-ruffled coastal water',
    eventPresentation: {
      accentColor: '#9bb0bb',
      mark: 'WINDHAVEN',
      subtitle: 'The wind writes the strategy',
      loadingCopy: 'Keep it low. Find the running line.',
      identityLine: 'Traditional links on the exposed coast',
      tierLabel: 'SIGNATURE',
    },
    wasteArea: { carryMultiplier: 0.91, consistencyMultiplier: 0.88, rollMultiplier: 0.72 },
  },
};
const pars = [4, 4, 4, 3, 5, 4, 4, 3, 4, 4, 3, 5, 4, 4, 3, 5, 4, 4];
const yards = [
  415, 445, 325, 215, 570, 430, 390, 175, 465, 420, 205, 590, 400, 455, 160, 545, 440, 470,
];
const names = [
  'Outward',
  'Marram',
  'Wind Choice',
  'Long Whistle',
  'Tide Run',
  'Pot Row',
  'Dune Gamble',
  'Postage',
  'Turn Home',
  'Crosswind',
  'Iron Test',
  'Bellows',
  'Double Green',
  'Shelterless',
  'Short Rest',
  'Long or Longer',
  'High Road',
  'Dune Gate',
];
const options: Partial<HolePlan>[] = [];
options[2] = {
  splitFairway: true,
  landingZones: [{ distance: 275, width: 58, preferredSide: 'right' }],
  bunkerCount: 5,
};
options[3] = { bunkerCount: 4 };
options[6] = { splitFairway: true, bunkerCount: 5 };
options[10] = { bunkerCount: 5 };
options[11] = { splitFairway: true, bunkerCount: 4 };
options[17] = { elevation: { tee: 2, landing: 13, green: 9 }, bunkerCount: 5, greenRadius: 19 };
export const createWindhavenLinksDocument = () =>
  authorCourse({
    ...windhavenLinksMetadata,
    plans: plans(names, pars, yards, options).map((plan) => ({
      ...plan,
      trees: plan.trees ?? 1,
      rocks: plan.rocks ?? 0,
    })),
  });
